/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module language
 */

import TextPartLanguage from './textpartlanguage';
import TextPartLanguageEditing from './textpartlanguageediting';
import TextPartLanguageUI from './textpartlanguageui';

export default {
	TextPartLanguage,
	TextPartLanguageEditing,
	TextPartLanguageUI
};
